import React, { useEffect, useState, useRef } from "react";
import "../../Styles/Components/Persons/PersonList.css";
// import Preview_Province from "./Preview_province";
import axios from "axios";
import Dialog_alert from '../PublicForms/Dialog_alert.js';
import {useNavigate } from "react-router-dom";
import LoaderComp from "../PublicForms/Loader.js";
import Config from "../PublicForms/Config.js";
import isTokenExpired from "../PublicForms/isTokenExpired.js";
import Navigation_Bar from "../PublicForms/Navigation_Bar.js";
import Header from "../PublicForms/Header.js";
import iconRemove from '../../Images/iconRemove.png';

const CityList = ()=>
{

    const[loading, setLoading] = useState(false);
    const[cityLst, setCityLst] = useState([]);
    const[runUseEffect, setRunUseEffect] = useState(true);
    const[runUseEffectActive, setRunUseEffectActive] = useState(false);
    const[width, setWidth] = useState(0);
    const[cityName, setCityName] = useState("");
    const[cityID, setCityID] = useState();
    const[pages, setPages] = useState();
    const[runPagination, setRunPagination] = useState(false);
    const[page, setPage] = useState(1);
    const[pagesList, setPagesList] = useState([]);
    const[message, setMessage] = useState([]);
    const[messTitle, setMessTitle] = useState("");
    const[showDialog, setShowDialog] = useState(false);
    const[previewShow, setPreviewShow] = useState(false); 
    const[openNav, setOpenNav] = useState(false);
    const[which, setWhich]= useState("Add");
    const Navigate = useNavigate();
    const prevPageRef = useRef();
    const[runUseDelete, setRunUseDelete] = useState(false);
    const pageSize = 10;
    prevPageRef.current = 1;
    
    useEffect(() => {
        if (localStorage.getItem('token')) {
          const token = localStorage.getItem('token');
          if (isTokenExpired(token)) {
            localStorage.removeItem('token');
            Navigate("/login");
        } else {
            // setUser(JSON.parse(localStorage.getItem('user')));
          }
        } else {
            Navigate("/login");
        }
      }, []);
    
      useEffect(() => {
        function handleResize() {
          setWidth(window.innerWidth)
        }
        
        window.addEventListener("resize", handleResize)
        
        handleResize()
        
        
      }, []);

      const handleNave = ()=>
    {
        setOpenNav(!openNav);

    }

    const handleNaveForm = ()=>
    {
        if(!openNav)
        {
            setOpenNav(!openNav)
        }
    }

    
    useEffect(()=>
        {
            const deleteData = async ()=>
                {

                  //0-fname, 1-lname, 2-bdate, 3-mobile, 4-home, 5-email, 6-city, 7-postal, 8-address, 9-descript
                  axios.delete(
                    `${Config.apiBaseUrl}/api/Cities/${cityID}`,{headers: {
                   
                      "Authorization":`Bearer ${localStorage.getItem('token')}`,
                    }
                  }).then(response => 
                  {
                      if(response.status == 204)
                      {
                          setMessTitle("توجه");
                          setMessage((prevMessages) => {
                              return [
                                ...prevMessages, // shallow copy into new array reference
                                "اطلاعات مورد نظر شما با موفقیت حذف شد",      // append new element
                              ];
                            });
                          setShowDialog(true);
                          setRunUseEffect(true);
              
                      }else
                      {
                          setMessTitle("خطا");
                          setMessage((prevMessages) => {
                              return [
                                ...prevMessages, // shallow copy into new array reference
                                "لطفا مجددا تلاش کنید",      // append new element
                              ];
                          });
                          setShowDialog(true);
                      }
              
                  }).catch((err) =>{
                      
                      if(err.response !== null && err.response !== undefined)
                      {
                        setMessage([]);
                        if(err.response.status == 401)
                        {
                            Navigate("/login");
            
            
                        }else if((err.response.status) === 400)
                        {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                      ...prevMessages, // shallow copy into new array reference
                                      ("اطلاعات این کاربر قبلا حذف شده است."),      // append new element
                                    ];
                                });
                                setShowDialog(true);
                
                        }else
                        {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                      ...prevMessages, // shallow copy into new array reference
                                      "لطفا مجددا تلاش کنید",      // append new element
                                    ];
                                });
                                setShowDialog(true);
                
                        }
                
                      }else if(err.message == "Network Error")
                      {
                          setMessTitle("خطا");
                          setMessage((prevMessages) => {
                              return [
                                ...prevMessages, // shallow copy into new array reference
                                "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                              ];
                          });
                          setShowDialog(true);
                      }else
                      {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    ("لطفا مجددا تلاش کنید"),      // append new element
                                ];
                            });                
                            
                            setShowDialog(true);
                      }
                  })
    
                  setRunUseDelete(false);
              }
    
            if(runUseDelete)
            {
                deleteData();
            }
    
        },[runUseDelete]);
    

      
    const citySearch = (search)=>
    {
        setCityName(search);
        setPagesList([]);
        setRunUseEffect(true);   
        
    }

   

    const closeOpenDialog = (open) =>
    {
        setCityLst([]);
        setShowDialog(false);
        setPagesList([]);         
        setRunPagination(false);
        setRunUseEffect(true);  
    }


    const changePage = (pageNum, pagesNum) => {
        setRunUseEffect(true);
        setRunPagination(true);
        setCityLst([]);
        setPage(pageNum);
        setPagesList([]);
    
       
      };

    useEffect(()=>
        {
            //pagesActive
            const pagesActive = async () => {
                setLoading(true);
                axios.get(`${Config.apiBaseUrl}/api/SubscriptDetails/1`,{headers: {
         
                    "Authorization":`Bearer ${localStorage.getItem('token')}`,
                  }
                }).then(response => 
                    {
                        if(response.status == 200)
                        {
                            var resp = Math.ceil(response.data.length/pageSize);
                            setPages(response.data.length/pageSize);
                            if(!runPagination)
                            {
                                if (resp <= 4 && resp >0) {
                                    for (let i = 1; i <= resp; i++) {
                                        pagesList.push(i);
                                    }
                                    }else if(resp>4) 
                                    {
                                    for (let i = 1; i <= 4; i++) {
                                        pagesList.push(i);
                                    }
                                    }
                            }
                              fetchActiveList();
                               
                        }else
                        {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "برقراری ارتباط با سرور مقدور نمی باشد، لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });                
                        
                        setShowDialog(true);
                        }
            
                    }).catch((err) =>{
            
                        if(err.response !== null && err.response !== undefined)
                            {
                                setMessage([]);
                                if(err.response.status === 401)
                                {
                                    Navigate("/login");
                                }else if((err.response.status) === 500)
                                {
                                    setMessTitle("خطا");
                                    setMessage((prevMessages) => {
                                        return [
                                            ...prevMessages, // shallow copy into new array reference
                                            (err.response.detail),      // append new element
                                        ];
                                    });
                                    setShowDialog(true);
                    
                                }else
                                {
                                    setMessTitle("خطا");
                                    setMessage((prevMessages) => {
                                        return [
                                            ...prevMessages, // shallow copy into new array reference
                                            "لطفا مجددا تلاش کنید",      // append new element
                                        ];
                                    });
                                    setShowDialog(true);
                        
                                }
                    
                        }else if(err.message == "Network Error")
                        {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                                ];
                            });
                            setShowDialog(true);
                        }else
                        {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                ("لطفا مجددا تلاش کنید"),      // append new element
                            ];
                        });                
                        
                        setShowDialog(true);
                        }
                   })
                
            }
            const fetchActiveList = async () => {
                axios.get(`${Config.apiBaseUrl}/api/SubscriptDetails/1`,{headers: {
         
                    "Authorization":`Bearer ${localStorage.getItem('token')}`,
                  }
                }).then(response => 
                {
                    if(response.status == 200)
                    {
                        setCityLst(response.data);
                        setRunUseEffectActive(false);
                        setLoading(false);
                           
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
        
                }).catch((err) =>{

                    setMessage([]);
                    if(err.response.status === 401)
                    {
                        Navigate("/login");
                    }else if((err.response.status) === 500)
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                (err.response.detail),      // append new element
                            ];
                        });
                        setShowDialog(true);
        
                    }else
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });
                        setShowDialog(true);
            
                    }
                     
                    
               })
            }

            //pages
            const getPages = async () => {
                setLoading(true);
                setCityLst([]);
                axios.get(`${Config.apiBaseUrl}/api/Cities?CityName=${cityName}`,{headers: {
         
                    "Authorization":`Bearer ${localStorage.getItem('token')}`,
                  }
                }).then(response => 
                {

                    if(response.status == 200)
                    {
                        var resp = Math.ceil(response.data.length/pageSize);
                        setPages(resp);
                        if(!runPagination)
                        {
                            if (resp <= 4 && resp >0) {
                                for (let i = 1; i <= resp; i++) {
                                  pagesList.push(i);
                                }
                              }else if(resp>4) 
                              {
                                for (let i = 1; i <= 4; i++) {
                                  pagesList.push(i);
                                }
                              }
                        }
                    
                          fetchCityList();
                           
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("برقراری ارتباط با سرور مقدور نمی باشد، لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
        
                }).catch((err) =>{
        
                    
                        if(err.response !== null && err.response !== undefined)
                        {
                            setMessage([]);
                            if(err.response.status === 401)
                            {
                                Navigate("/login");
                            }else if((err.response.status) === 500)
                            {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                        ...prevMessages, // shallow copy into new array reference
                                        (err.response.detail),      // append new element
                                    ];
                                });
                                setShowDialog(true);
                
                            }else
                            {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                        ...prevMessages, // shallow copy into new array reference
                                        "لطفا مجددا تلاش کنید",      // append new element
                                    ];
                                });
                                setShowDialog(true);
                    
                            }
                
                        }else if(err.message == "Network Error")
                        {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                                ];
                            });
                            setShowDialog(true);
                        }else
                        {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                ("لطفا مجددا تلاش کنید"),      // append new element
                            ];
                        });                
                        
                        setShowDialog(true);
                        } 
               })
            }
    
            const fetchCityList = async () => {
                setCityLst([]);
                axios.get(`${Config.apiBaseUrl}/api/Cities?CityName=${cityName}&PageSize=${pageSize}&PageNumber=${page-1}`,{headers: {
         
                    "Authorization":`Bearer ${localStorage.getItem('token')}`,
                  }
                }).then(response => 
                {
                    if(response.status == 200)
                    {
                        console.log(response.data)
                        setCityLst(response.data);
                        setRunUseEffect(false);
                        setLoading(false);
                           
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
        
                }).catch((err) =>{
        

                    if(err.response !== null && err.response !== undefined)
                        {
                            setMessage([]);
                            if((err.response.status) === 500)
                            {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                        ...prevMessages, // shallow copy into new array reference
                                        (err.response.detail),      // append new element
                                    ];
                                });
                                setShowDialog(true);
                
                            }else
                            {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                        ...prevMessages, // shallow copy into new array reference
                                        "لطفا مجددا تلاش کنید",      // append new element
                                    ];
                                });
                                setShowDialog(true);
                    
                            }
                
                    }else if(err.message == "Network Error")
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                            ];
                        });
                        setShowDialog(true);
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
                  
                    
               })
            }
    
            if(runUseEffect === true)
            {
                getPages();

                if(runPagination)
                {

                    if (pages <= 4 && pages >0) {
                        for (let i = 1; i <= pages; i++) {
                            pagesList.push(i);
                        }
                    } else 
                    {
                        if (page == 1 || page == 2) {
                            for (let i = 1; i <= 4; i++) {
                            pagesList.push(i);
                            }
                        } else if (page > 2 && page <= pages - 2) {
                            for (let i = page - 2; i <= page + 2; i++) {
                            pagesList.push(i);
                            }
                        } else if (page > pages - 2 && page != pages) {
                            for (let i = page - 2; i <= pages; i++) {
                            pagesList.push(i);
                            }
                        } else if (page == pages-1) {
                            for (let i = page - 3; i <= pages; i++) {
                            pagesList.push(i);
                            }
                        }else if(page == pages)
                        {
                            for(let i = page - 4; i<= pages; i++)
                            {
                                pagesList.push(i);
                            }
                        }
                        
                   }
                }
                     
    
            }
    
            if(runUseEffectActive === true)
            {
                pagesActive();
                if(runPagination)
                {
                    setPagesList([]);
                    if (pages <= 4 && pages >0) {
                        for (let i = 1; i <= pages; i++) {
                            pagesList.push(i);
                        }
                    } else 
                    {
                        if (page == 1 || page == 2) {
                            for (let i = 1; i <= 4; i++) {
                            pagesList.push(i);
                            }
                        } else if (page > 2 && page <= pages - 2) {
                            for (let i = page - 2; i <= page + 2; i++) {
                            pagesList.push(i);
                            }
                        } else if (page > pages - 2 && page != pages) {
                            for (let i = page - 2; i <= pages; i++) {
                            pagesList.push(i);
                            }
                        } else if (page == pages-1) {
                            for (let i = page - 3; i <= pages; i++) {
                            pagesList.push(i);
                            }
                        }else if(page == pages)
                            {
                                for(let i = page - 4; i<= pages; i++)
                                {
                                    pagesList.push(i);
                                }
                        }
                        
                   }
                }
    
            }
    
        },[runUseEffectActive, runUseEffect])
    
        if(width>999)
        {
            if(loading)
                {
                    return(<div className="personLst">
                            <p className="personLst-loader-txt"> لطفا چند لحظه صبر کنید...</p>   
                            <div className="personLst-loader">
                            <LoaderComp />
                            </div>
                        
                        </div>)
                }else
                {
                    return(
    
                        <div className="personLst-all">
                            <Header handleNave={handleNave}/>
    
                                
                             <div className="navClass">
                                        <Navigation_Bar />
                                    
                                    </div>
                                   
                                <div className="personLst">
    
                                <div className="personLst-top-page ">
                                    <div className="searchContainer">
                                        <input type="text"  placeholder="جستجو..." value={cityName}  onChange={(e)=>citySearch(e.target.value)}/>
                                    </div>
                                    
                                    
                                    </div>
    
                                    <div className="table-responsive-sm personLst-tbl ">
                                        <div className="table-responsive">
                                            <table className="table table-condensed">
                                                <thead>
                                
                                                <tr>
                                                    <td>ردیف</td>
                                                    <td>نام شهر</td>
                                                    <td>نام استان</td>
                            
                                                    <td></td>
                                                </tr>
                                
                                                </thead>
                                                <tbody>
                                                {
                                                    cityLst.map((plst, i)=>
                                                    {
                                                        
                                                        return(
                                                            <tr key={plst.cityID} onClick={()=>{
                                                                // setCityID(plst.cityID);
                                                                // setPreviewShow(true);
                                                                // setWhich("Edit");
    
                                                            }}>
                                                                <td>{i+(pageSize*(page-1))+1}</td>
                                                                <td>{plst.cityName}</td>
                                                                <td>{plst.province.provinceName}</td>
                                                                <td className="tbl-details" onClick={()=>{setCityID(plst.cityID)
                                                                    setRunUseDelete(true);
                                                                }}><img className="subRecImg" src={iconRemove}/> </td>                                                                                                                          
                                                            </tr>
                                                        )                
                                                        
                                                    })
                                                }
                                                </tbody>
                                                
                                            </table>
    
                                                <div
                                                    style={{
                                                    
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginTop: "5%",
                                                    }}
                                                    >
                                                    <nav aria-label="Page navigation" style={{
                                                    
                                                    }}>
                                                        <ul className="pagination" >
                                                        <li key= "next" className="page-item">
                                                            <a
                                                            key = {999999999}
                                                            id={page < pages ? page + 1 : page}
                                                            className="page-item"
                                                            href="#"
                                                            aria-label="Next"
                                                            onClick={() =>
                                                                page < pages ? changePage(page + 1, pages) : null
                                                            }
                                                            
                                                            >
                                                            <span
                                                                aria-hidden="true"
                                                                style={page == 1 ? { color: "grey" } : null}
                                                            >
                                                                &laquo;
    
                                                            </span>
                                                            <span className="sr-only">Next</span>
                                                            </a>
                                                        </li>
                                                        {pagesList.slice(0).reverse().map((pageList,index) => {
                                                            return (
                                                            <li
                                                                key={index}
                                                                className="page-item"
                                                                onClick={() => changePage(pageList, pages)}
                                                            >
                                                                <a
                                                                id={pageList}
                                                                className={
                                                                    pageList == page ? "page-link active" : "page-link"
                                                                }
                                                                href="#"
                                                                >
                                                                {pageList}
                                                                </a>
                                                            </li>
                                                            );
                                                        })}
                                                        <li key= {0} className="page-item">
                                                            <a
                                                                id={page > 1 ? page - 1 : page}
                                                                className="page-item"
                                                                href="#"
                                                                aria-label="Previous"
                                                                onClick={() =>
                                                                    page > 1 ? changePage(page - 1, pages) : null
                                                                }
                                                            >
                                                            <span
                                                                aria-hidden="true"
                                                                style={pages == page ? { color: "grey" } : null}
                                                            >
                                                                &raquo;
    
                                                            </span>
                                                            <span className="sr-only">prev</span>
                                                            </a>
                                                        </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                            
                                        {/* <button type="button" className="btn btn-new" onClick={()=> showAddModal()}>جدید</button> */}
    
                                    
                                    </div>    
    
    
                                    {/* <button type="button" className="btn btn-settings" onClick={()=> setShowSettings(true)}>چاپ</button>  */}
                                </div>
    
                            </div>
                                    
                        
                    )
                }
        }else
        {
            if(loading)
                {
                    return(<div className="personLst">
                            <p className="personLst-loader-txt"> لطفا چند لحظه صبر کنید...</p>   
                            <div className="personLst-loader">
                            <LoaderComp />
                            </div>
                        
                        </div>)
                }else
                {
                    return(
                        <div className="personLst-all-responsive">

                            <div className= {openNav? "navClass" : "navClass navClassOpen"}>
                                

                                <Navigation_Bar />
                                
                            </div>

                           <div className="personLst-all">
                            <Header handleNave={handleNave}/>
                                <div className="personLst" onClick={()=>handleNaveForm()}>
    
                                <div className="personLst-top-page ">
                                    <div className="searchContainer">
                                        <input type="text"  placeholder="جستجو..." value={cityName}  onChange={(e)=>citySearch(e.target.value)}/>
                                    </div>
                                    
                                    
                                    </div>
    
                                    <div className="table-responsive-sm personLst-tbl ">
                                        <div className="table-responsive">
                                            <table className="table table-condensed">
                                                <thead>
                                
                                                <tr>
                                                    <td>ردیف</td>
                                                    <td>نام شهر</td>
                                                    <td>نام استان</td>
                            
                                                    <td></td>
                                                </tr>
                                
                                                </thead>
                                                <tbody>
                                                {
                                                    cityLst.map((plst, i)=>
                                                    {
                                                        
                                                        return(
                                                            <tr key={plst.cityID} onClick={()=>{
                                                                // setCityID(plst.cityID);
                                                                // setPreviewShow(true);
                                                                // setWhich("Edit");
    
                                                            }}>
                                                                <td>{i+(pageSize*(page-1))+1}</td>
                                                                <td>{plst.cityName}</td>
                                                                <td>{plst.province.provinceName}</td>
                                                                <td className="tbl-details" onClick={()=>{setCityID(plst.cityID);
                                                                    setRunUseDelete(true);
                                                                }}><img className="subRecImg" src={iconRemove}/> </td>                                                                                                                          
                                                            </tr>
                                                        )                
                                                        
                                                    })
                                                }
                                                </tbody>
                                                
                                            </table>
    
                                                <div
                                                    style={{
                                                    
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginTop: "5%"
                                                    }}
                                                    >
                                                    <nav aria-label="Page navigation" >
                                                        <ul className="pagination" >
                                                        <li key= "next" className="page-item">
                                                            <a
                                                            key = {999999999}
                                                            id={page < pages ? page + 1 : page}
                                                            className="page-item"
                                                            href="#"
                                                            aria-label="Next"
                                                            onClick={() =>
                                                                page < pages ? changePage(page + 1, pages) : null
                                                            }
                                                            
                                                            >
                                                            <span
                                                                aria-hidden="true"
                                                                style={page == 1 ? { color: "grey" } : null}
                                                            >
                                                                &laquo;
    
                                                            </span>
                                                            <span className="sr-only">Next</span>
                                                            </a>
                                                        </li>
                                                        {pagesList.slice(0).reverse().map((pageList,index) => {
                                                            return (
                                                            <li
                                                                key={index}
                                                                className="page-item"
                                                                onClick={() => changePage(pageList, pages)}
                                                            >
                                                                <a
                                                                id={pageList}
                                                                className={
                                                                    pageList == page ? "page-link active" : "page-link"
                                                                }
                                                                href="#"
                                                                >
                                                                {pageList}
                                                                </a>
                                                            </li>
                                                            );
                                                        })}
                                                        <li key= {0} className="page-item">
                                                            <a
                                                                id={page > 1 ? page - 1 : page}
                                                                className="page-item"
                                                                href="#"
                                                                aria-label="Previous"
                                                                onClick={() =>
                                                                    page > 1 ? changePage(page - 1, pages) : null
                                                                }
                                                            >
                                                            <span
                                                                aria-hidden="true"
                                                                style={pages == page ? { color: "grey" } : null}
                                                            >
                                                                &raquo;
    
                                                            </span>
                                                            <span className="sr-only">prev</span>
                                                            </a>
                                                        </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                            
                                        {/* <button type="button" className="btn btn-new" onClick={()=> showAddModal()}>جدید</button> */}
    
                                    
                                    </div>    
    
                                    </div>
    
                            </div>

                        </div>
                                    
                        
                    )
                }
        }
            
        
}

export default CityList;

